import { render } from "./ILoader.vue?vue&type=template&id=33538d48"
import script from "./ILoader.vue?vue&type=script&lang=js"
export * from "./ILoader.vue?vue&type=script&lang=js"

import "./ILoader.vue?vue&type=style&index=0&id=33538d48&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__